export default [{
  label: 'Razão social', field: 'razaoSocial', editable: true, evento: null, type: 'custom',
},
{ label: 'CNPJ/CPF', field: 'cadastroFederal', type: 'custom' },
{
  label: 'Lidos/Não lidos', field: 'qtdNaoLidas', type: 'custom',
},
{
  label: 'Consultado em', field: 'consultadoEm', type: 'custom',
}]
